module.exports = __webpack_public_path__ + "img/ONT.fe215ead.svg";